export { ContactPageView as default } from './ContactPageView';
